// Product page countdown timer js start
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

if (getCookie('timer') > new Date().getTime()) {
  var time = getCookie('timer');
  var timer = setInterval(function () {
    var left = time - new Date().getTime();
    var hours = Math.floor(left / (1000 * 60 * 60));
    var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((left % (1000 * 60)) / 1000);

    hours = ('0' + hours).slice(-2);
    minutes = ('0' + minutes).slice(-2);
    seconds = ('0' + seconds).slice(-2);

    document.querySelector('#js-clock-hours').innerHTML = hours;
    document.querySelector('#js-clock-minutes').innerHTML = minutes;
    document.querySelector('#js-clock-seconds').innerHTML = seconds;

    if (left <= 1000) {
      clearInterval(timer);
      document.cookie = 'timer=""; path=/; expires=-1';
      location.reload();
    }
  }, 1000);
} else {
  var time = new Date().getTime() + 7981974;
  setCookie('timer', time, 1);
  var timer = setInterval(function () {
    var left = time - new Date().getTime();
    var hours = Math.floor(left / (1000 * 60 * 60));
    var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((left % (1000 * 60)) / 1000);

    hours = ('0' + hours).slice(-2);
    minutes = ('0' + minutes).slice(-2);
    seconds = ('0' + seconds).slice(-2);

    document.querySelector('#js-clock-hours').innerHTML = hours;
    document.querySelector('#js-clock-minutes').innerHTML = minutes;
    document.querySelector('#js-clock-seconds').innerHTML = seconds;

    if (left <= 1000) {
      clearInterval(timer);
      document.cookie = 'timer=""; path=/; expires=-1';
      location.reload();
    }
  }, 1000);
}
// Product page countdown timer js end
